//
// Core extensions
//

if (typeof String.prototype.startsWith !== 'function')
{
    String.prototype.startsWith = function(search, pos)
    {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
}

if (typeof String.prototype.endsWith !== 'function')
{
    String.prototype.endsWith = function(search, this_len)
    {
        if (this_len === undefined || this_len > this.length)
        {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

if (typeof String.prototype.replaceMultiple !== 'function') {
    String.prototype.replaceMultiple = function(findArr, replaceWith) {
        var str = this;
        for (var i = 0; i < findArr.length; i++) {
            str = str.replace(findArr[i], replaceWith);
        }
        return str;
    };
}

if (typeof String.prototype.isNullOrWhiteSpace !== 'function')
{
    String.prototype.isNullOrWhiteSpace = function() {
        return (!this || this.length === 0 || /^\s*$/.test(this));
    };
}

//
// Request animation frame shim
//

window.requestAnimFrame = window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || function (callback) {
        window.setTimeout(callback, 1000 / 60);
};

//
// Math easing functions for animation
//

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) {
        return c/2*t*t + b;
    }
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
};
